function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Fragment } from 'react';
import { classnames, pick } from '@bydesign-ui/utils';
import { useRefCallback } from '@bydesign-ui/hooks';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { Input } from '../../input';
import { ManualTrigger } from '../../popover/components/ManualTrigger';
import { ClickTrigger } from '../../popover/components/ClickTrigger';
import { FocusTrigger } from '../../popover/components/FocusTrigger';
import { RenderSelectedWrapper } from '../../util/RenderSelectedWrapper';
export function SelectInput(props) {
  var triggerId = props.triggerId,
      disabled = props.disabled,
      children = props.children,
      className = props.className,
      _props$triggerType = props.triggerType,
      triggerType = _props$triggerType === void 0 ? 'click' : _props$triggerType,
      width = props.width,
      show = props.show,
      displayInfo = props.displayInfo,
      renderSelected = props.renderSelected,
      renderPlaceholder = props.renderPlaceholder,
      _props$unsetHeight = props.unsetHeight,
      unsetHeight = _props$unsetHeight === void 0 ? true : _props$unsetHeight,
      _props$htmlReadOnly = props.htmlReadOnly,
      htmlReadOnly = _props$htmlReadOnly === void 0 ? false : _props$htmlReadOnly,
      extra = _objectWithoutProperties(props, ["triggerId", "disabled", "children", "className", "triggerType", "width", "show", "displayInfo", "renderSelected", "renderPlaceholder", "unsetHeight", "htmlReadOnly"]);

  var cls = classnames(usePrefixCls('select-input'), className);
  var Trigger = triggerType === 'manual' && ManualTrigger || triggerType === 'focus' && FocusTrigger || ClickTrigger;
  var clearHandle = useRefCallback(function () {
    var _a;

    return (_a = extra.onValueChange) === null || _a === void 0 ? void 0 : _a.call(extra, '');
  });
  var locale = useLocale('input.placeholder');

  var getPlaceholder = function getPlaceholder(children) {
    var _a, _b;

    var placeholderContent = typeof renderPlaceholder === 'function' ? renderPlaceholder((_a = extra.placeholder) !== null && _a !== void 0 ? _a : locale) : (_b = extra.placeholder) !== null && _b !== void 0 ? _b : locale;
    return children || placeholderContent;
  };

  var getSelectInput = function getSelectInput() {
    if (typeof renderSelected === 'function') {
      var _pick = pick(extra, ['suffix', 'placeholder', 'size', 'invalid', 'clearable', 'inputRef']),
          _pick2 = _slicedToArray(_pick, 1),
          _props = _pick2[0];

      return React.createElement(RenderSelectedWrapper, Object.assign({
        disabled: disabled,
        focus: show,
        onClear: clearHandle,
        innerClassName: (displayInfo === null || displayInfo === void 0 ? void 0 : displayInfo.length) ? '' : 'placeholder',
        unsetHeight: unsetHeight
      }, _props), getPlaceholder((displayInfo === null || displayInfo === void 0 ? void 0 : displayInfo.length) ? renderSelected(displayInfo[0]) : null));
    }

    return React.createElement(Fragment, null, React.createElement(Input, Object.assign({}, extra, {
      disabled: disabled,
      needGrouped: false,
      onBlur: function onBlur(event) {
        event.stopPropagation();
      },
      htmlReadOnly: htmlReadOnly
    })), children);
  };

  return React.createElement(Trigger, Object.assign({
    triggerId: triggerId,
    className: cls,
    disabled: disabled,
    style: {
      width: width
    }
  }, triggerType === 'manual' && {
    show: show
  } || {}), getSelectInput());
}